"use strict";

exports.__esModule = true;
exports.ScheduleAgendasField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFinalFormArrays = require("react-final-form-arrays");
var _core = require("@blueprintjs/core");
var _libCalendar = require("@vimana/lib-calendar");
var _AgendaFieldSet = require("../Agenda/AgendaFieldSet");
var _Core = require("../../Core");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _common = require("../../Device/common");
var _Theme = require("../../Theme");
var _dec, _class, _ScheduleAgendasField;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var FlexTabs = (0, _styledComponents["default"])(_core.Tabs).withConfig({
  displayName: "ScheduleAgendasField__FlexTabs",
  componentId: "sc-108pm3w-0"
})([".bp6-tab-panel{flex:1;}"]);
var AgendaLabelSpan = _styledComponents["default"].span.withConfig({
  displayName: "ScheduleAgendasField__AgendaLabelSpan",
  componentId: "sc-108pm3w-1"
})(["color:", ";"], function (props) {
  return props.hasError ? (0, _Theme.val)("FormErrorColor") : "unset";
});
var ScheduleAgendasFieldHeading = _styledComponents["default"].div.withConfig({
  displayName: "ScheduleAgendasField__ScheduleAgendasFieldHeading",
  componentId: "sc-108pm3w-2"
})(["font-size:1.17em;font-weight:bold;"]);
var getAgendaLabel = function getAgendaLabel(agenda, index, devices, hasError) {
  var device = (0, _common.getDevice)(devices, agenda.devices[0]);
  if (agenda.devices.length === 1) {
    return /*#__PURE__*/_react["default"].createElement(AgendaLabelSpan, {
      hasError: hasError,
      "data-testid": "ScheduleAgendaTab-" + index
    }, device ? device.name : agenda.devices[0]);
  }
  if (agenda.devices.length > 1) {
    return /*#__PURE__*/_react["default"].createElement(AgendaLabelSpan, {
      hasError: hasError,
      "data-testid": "ScheduleAgendaTab-" + index
    }, device ? device.name : agenda.devices[0], " (+", agenda.devices.length - 1, " ", "more)");
  }
  return index === 0 ? /*#__PURE__*/_react["default"].createElement(AgendaLabelSpan, {
    hasError: hasError,
    "data-testid": "ScheduleAgendaTab-" + index
  }, "Plant Agenda") : /*#__PURE__*/_react["default"].createElement("em", {
    "data-testid": "ScheduleAgendaTab-" + index
  }, "New Agenda");
};
var validateAgendas = function validateAgendas(agendas) {
  if (agendas.length === 0) {
    return "Must specify at least one agenda.";
  }
  var errors = agendas.map(function (agenda, index) {
    try {
      (0, _libCalendar.validateAgenda)(agenda);
    } catch (error) {
      return {
        error: error.message,
        index: index
      };
    }
  }).filter(function (error) {
    return !!error;
  });
  if (errors.length) {
    return errors;
  }
};
var ScheduleAgendasField = exports.ScheduleAgendasField = (_dec = _DeviceListContext.DeviceListContext.withContext, (0, _Core.withTranslator)(_class = _dec(_class = (_ScheduleAgendasField = /*#__PURE__*/function (_Component) {
  function ScheduleAgendasField() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleCreateAgendaClick = function (agendas) {
      if (agendas === void 0) {
        agendas = [];
      }
      if (agendas.length) {
        var devices = _this.props.devices;
        var defaultDevices = devices[0] ? [devices[0].uuid] : [];
        var eventConfigs = agendas[0].eventConfigs;
        _this.props.onCreateAgenda({
          devices: defaultDevices,
          eventConfigs: eventConfigs
        });
        return;
      }
      _this.props.onCreateAgenda({
        devices: [],
        eventConfigs: []
      });
    };
    return _this;
  }
  _inheritsLoose(ScheduleAgendasField, _Component);
  var _proto = ScheduleAgendasField.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      form = _this$props.form,
      devices = _this$props.devices,
      translate = _this$props.translator.translate,
      calendarConfig = _this$props.calendarConfig,
      onSelectEventConfig = _this$props.onSelectEventConfig,
      onCreateEventConfig = _this$props.onCreateEventConfig,
      onDeleteAgenda = _this$props.onDeleteAgenda,
      selectedAgendaID = _this$props.selectedAgendaID,
      selectedEventConfigID = _this$props.selectedEventConfigID,
      onSelectAgenda = _this$props.onSelectAgenda;
    return /*#__PURE__*/_react["default"].createElement(_reactFinalFormArrays.FieldArray, {
      name: "agendas",
      validate: validateAgendas
    }, function (_ref) {
      var fields = _ref.fields,
        meta = _ref.meta;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "ScheduleAgendasField"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/_react["default"].createElement(ScheduleAgendasFieldHeading, null, translate("ScheduleAgendasField.heading", "Agendas")), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
        style: {
          marginLeft: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        "data-testid": "ScheduleCreateAgendaButton",
        icon: "add",
        onClick: function onClick() {
          return _this2.handleCreateAgendaClick(fields.value);
        }
      }, translate("Schedule.createAgendaButton.text", "Add Agenda")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: "delete",
        onClick: _this2.props.onDeleteAgenda,
        disabled: fields.value.length === 0 || !selectedAgendaID
      }, translate("Schedule.deleteAgendaButton.text", "Delete this agenda")))), fields.value.length === 0 && /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
        visual: "time",
        title: translate("ScheduleAgendasField.agendas.nonIdealState.title", "No agendas specified"),
        description: translate("ScheduleAgendasField.agendas.nonIdealState.description", "Agendas apply to specific devices or the entire Plant."),
        action: /*#__PURE__*/_react["default"].createElement(_core.Button, {
          icon: "add",
          onClick: function onClick() {
            return _this2.handleCreateAgendaClick();
          }
        }, translate("ScheduleAgendasField.agendas.nonIdealState.createButton", "Add Agenda"))
      }, meta.touched && meta.error), fields.value.length > 0 && /*#__PURE__*/_react["default"].createElement(FlexTabs, {
        "data-testid": "ScheduleAgendas",
        id: "ScheduleAgendas",
        vertical: true,
        renderActiveTabPanelOnly: true,
        selectedTabId: selectedAgendaID ? "agenda-" + selectedAgendaID : "agenda-",
        onChange: function onChange(selectedTabId) {
          return onSelectAgenda(selectedTabId.slice(7));
        }
      }, fields.value.map(function (agenda, index) {
        var error = getError(meta.error, index);
        return /*#__PURE__*/_react["default"].createElement(_core.Tab, {
          key: String(index),
          id: "agenda-" + agenda.id,
          title: getAgendaLabel(agenda, index, devices, !!error),
          panel: /*#__PURE__*/_react["default"].createElement(_AgendaFieldSet.AgendaFieldSet, {
            key: agenda.id,
            isPlantAgenda: index === 0,
            selectedEventConfigID: selectedEventConfigID,
            error: error,
            onSelectEventConfig: onSelectEventConfig,
            onCreateEventConfig: onCreateEventConfig,
            onDeleteAgenda: onDeleteAgenda,
            prefix: fields.name + "[" + index + "]",
            calendarConfig: calendarConfig,
            form: form,
            agenda: agenda
          })
        });
      })));
    });
  };
  return ScheduleAgendasField;
}(_react.Component), _ScheduleAgendasField.defaultProps = {
  translator: undefined,
  devices: undefined
}, _ScheduleAgendasField)) || _class) || _class);
var isDefined = function isDefined(error) {
  return !!error;
};
var getErrors = function getErrors(errors, index) {
  return errors.filter(isDefined).map(function (err) {
    return getError(err, index);
  }).filter(isDefined);
};

// flow doesn't understand type checks if they are in the form of variables

function getError(error, index) {
  var isOfTypeString = typeof error === "string";
  if (isOfTypeString) {
    return error;
  }
  var isNotOfTypeObject = typeof error !== "object";
  var isNull = error === null;
  var isErrorNotDefined = isNotOfTypeObject || isNull;
  if (isErrorNotDefined) {
    return undefined;
  }
  if (Array.isArray(error)) {
    var errors = getErrors(error, index);
    if (errors.length) {
      return errors;
    } else {
      return undefined;
    }
  }
  var isOfTypeObject = typeof error === "object";
  if (isOfTypeObject) {
    // $FlowFixMe
    var keys = Object.keys(error);
    var doesObjectHaveIndexKey = keys.includes("index");
    if (doesObjectHaveIndexKey) {
      // $FlowFixMe
      var isErrorForCurrentIndex = error.index === index;
      if (isErrorForCurrentIndex) {
        // $FlowFixMe
        return error.error;
      }
      return undefined;
    } else {
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        // $FlowFixMe
        var errorForKey = getError(error[key], index);
        if (errorForKey) {
          return errorForKey;
        }
      }
    }
  }
}